import AppNameListPage from '../views/appName/list';
import AppNameEditPage from '../views/appName/edit';
import {appNamePermissions} from 'views/appName/permissions';
import {IRouteItem} from 'routes';

const paths = {
  appNameListPage: '/app-name',
  appNameCreatePage: '/app-name/new',
  appNameEditPage: '/app-name/:id',
};

const routes: IRouteItem[] = [
  {
    name: 'App Name',
    path: paths.appNameListPage,
    icon: 'apps',
    component: AppNameListPage,
    showInSideBar: true,
    breadcrumb: {items: [{text: 'App Names', route: paths.appNameListPage}]},
    requiredPermissions: appNamePermissions.APPNAME_VIEW.enabled,
  },
  {
    name: 'App Name Single',
    path: paths.appNameEditPage,
    component: AppNameEditPage,
    breadcrumb: {
      items: [{text: 'App Names', route: paths.appNameListPage}, {text: 'Edit App Name'}],
    },
    requiredPermissions: appNamePermissions.APPNAME_VIEW.enabled,
  },
];

export default {
  paths,
  routes,
};
